import React, { RefObject, useEffect, useMemo, useState } from "react";

import { Table } from "antd";
import classNames from "classnames";

import { ArrowSVG } from "assets/icons";
import { Button } from "components/Button";
import { useUserData, useWindowSize } from "hooks";

import { getMobileColumns, getTableData, getColumns } from "./tableDefinition";
import { useStoreInfoAboutExpandInLocalStorage } from "./useStoreInfoAboutExpandInLocalStorage";

import styles from "./ComparisonTiersTable.module.scss";

type Props = {
  defaultShowComparison?: boolean;
};

export const ComparisonTiersTable = ({ defaultShowComparison }: Props) => {
  const { isMobile } = useWindowSize();
  const { data } = useUserData();
  const { showComparison, onToggle } = useStoreInfoAboutExpandInLocalStorage(defaultShowComparison);

  const toggleButton = (
    <div className={styles.compareTiersBtnBox}>
      <Button type={"outline"} onClick={onToggle}>
        {showComparison ? "Show less" : "Compare Tiers"}{" "}
        <ArrowSVG className={classNames({ [styles.arrowFlip]: showComparison })} />
      </Button>
    </div>
  );

  const tableData = getTableData(data?.UKFinProm);
  const columns = useMemo(() => getColumns(data?.UKFinProm), [data?.UKFinProm]);
  const mobileColumns = useMemo(() => getMobileColumns(data?.UKFinProm), [data?.UKFinProm]);

  return (
    <>
      {showComparison && (
        <div className={styles.comparisonTable}>
          <div className={styles.tiersContainer}>
            <Table
              sticky
              rowClassName={(record, idx) => {
                if (record.isSpacer) return styles.spacerRow;
                if (record.isTitle) return styles.sectionRow;
                return idx % 2 === 0 ? styles.rowLight : styles.rowDark;
              }}
              className={styles.table}
              dataSource={tableData}
              columns={isMobile ? mobileColumns : columns}
              pagination={false}
              footer={undefined}
              expandable={
                isMobile
                  ? {
                      defaultExpandAllRows: true,
                      defaultExpandedRowKeys: [...tableData.map((x) => x.key)],
                      showExpandColumn: false,
                      rowExpandable: (record) => !record.isSpacer && !record.isTitle,
                      expandedRowClassName: () => styles.mobileTableRowTitle,
                      expandedRowRender: (record) => <div>{record.features}</div>,
                    }
                  : undefined
              }
            />
          </div>
        </div>
      )}

      {toggleButton}
    </>
  );
};
